window.salesInvoiceCreditedByFormatter = function(value, row) {
    let html = '';
    if (row.credited_by) {
        html += row.credited_by;
    }
    return html;
}
